import * as D from '../../def';
export const annotationEth:D.IAnnotation = {
  circle: {
    pricePoints: [
      {
        color: 'green',
        date: {
          year: 2015,
          month: 10,
          day: 22,
        },
      },
      {
        color: 'red',
        date: {
          year: 2016,
          month: 3,
          day: 31,
        },
      },
      {
        color: 'red',
        date: {
          year: 2016,
          month: 6,
          day: 28,
        },
      },
      {
        color: 'red',
        date: {
          year: 2017,
          month: 6,
          day: 14,
        },
      },
      {
        color: 'red',
        date: {
          year: 2018,
          month: 1,
          day: 14,
        },
      },
      {
        color: 'green',
        date: {
          year: 2017,
          month: 1,
          day: 3,
        },
      },
      {
        color: 'green',
        date: {
          year: 2018,
          month: 12,
          day: 16,
        },
      },
      {
        color: 'green',
        date: {
          year: 2020,
          month: 1,
          day: 10,
        },
      },
      {
        color: 'red',
        date: {
          year: 2021,
          month: 2,
          day: 23,
        },
      },
      {
        color: 'red',
        date: {
          year: 2021,
          month: 5,
          day: 15,
        },
      },
      {
        color: 'red',
        date: {
          year: 2021,
          month: 9,
          day: 19,
        },
      },
    ],
    IndicePoints: [
      {
        color: 'green',
        date: {
          year: 2015,
          month: 10,
          day: 22,
        },
      },
      {
        color: 'red',
        date: {
          year: 2016,
          month: 3,
          day: 31,
        },
      },
      {
        color: 'red',
        date: {
          year: 2016,
          month: 6,
          day: 28,
        },
      },
      {
        color: 'red',
        date: {
          year: 2017,
          month: 6,
          day: 14,
        },
      },
      {
        color: 'red',
        date: {
          year: 2018,
          month: 1,
          day: 14,
        },
      },
      {
        color: 'green',
        date: {
          year: 2017,
          month: 1,
          day: 3,
        },
      },
      {
        color: 'green',
        date: {
          year: 2018,
          month: 12,
          day: 16,
        },
      },
      {
        color: 'green',
        date: {
          year: 2020,
          month: 1,
          day: 10,
        },
      },
      {
        color: 'red',
        date: {
          year: 2021,
          month: 2,
          day: 23,
        },
      },
      {
        color: 'red',
        date: {
          year: 2021,
          month: 5,
          day: 15,
        },
      },
      {
        color: 'red',
        date: {
          year: 2021,
          month: 9,
          day: 19,
        },
      },
    ],
  },
};
